import { Editor } from "@fronterahealth/frontera-ui-components/WYSIWYG/Editor";
import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";

import { ReportFieldInputBaseProps } from "@components/ReportField/types";

export const ReportFieldWysiwyg: React.FC<ReportFieldInputBaseProps> = ({
  value,
  onChange,
  placeholder,
  onFocus,
  onBlur,
  variant,
  disabled,
  className,
  ariaInvalid,
}) => {
  return (
    <Editor
      initialContent={value ?? ""}
      placeholder={placeholder}
      onChange={(markdown) => {
        onChange(markdown);
      }}
      readOnly={disabled}
      variant={variant}
      onFocus={onFocus}
      onBlur={onBlur}
      className={cn(
        disabled && "wysiwyg-editor-container-disabled",
        ariaInvalid && "border-semantic-stroke-negative ring-3 ring-semantic-stroke-negative/20",
        className,
      )}
    />
  );
};
